import styled from 'styled-components';
import { breakpoints } from 'config/config';

export const StyledAllProducts = styled('div')`
  background-color: ${({ theme }) => theme.whiteSmoke};

  .discount-items {
    display: none;
  }

  .icon,
  .ant-form-item {
    margin-bottom: 0 !important;
    padding-bottom: 0;
  }

  .banner-image-wrapper {
    padding-left: 0;
    padding-right: 0;
  }

  .product-name-and-qmarks-container {
    .product-name {
      margin-top: 0 !important;
    }
  }

  .ant-pagination-item {
    margin-right: 0;
  }

  .ant-pagination-prev {
    margin-right: 24px;
  }

  .ant-pagination-next {
    margin-left: 24px;
  }

  .popular-categories {
    padding-bottom: 50px;
    padding-top: 100px;

    h1 {
      margin-bottom: 19px;
    }
  }

  .products-filters-container {
    .category_name {
      display: none;
    }
    display: flex;
    flex-direction: row;
    column-gap: 50px;

    .ant-form {
      padding-right: 0;
    }

    .ant-select-selector {
      background-color: ${({ theme }) => theme.lightGrey} !important;
    }

    .ant-spin-nested-loading {
      width: 100%;
    }

    .products-wrapper {
      .products {
        flex-wrap: wrap;
        padding-top: 40px;
        display: grid;
        grid-template-columns: repeat(auto-fill, minmax(220px, 1fr));
        gap: 20px;
        justify-content: center;
        justify-items: center;
      }

      .pagination {
        display: flex;
        justify-content: center;
        align-items: center;
        padding: 77px 0 83px 0;

        li {
          display: flex;
          align-items: center;
          justify-content: center;
          padding-top: 0;
          font-size: 16px;
          font-weight: 500;
          line-height: 22px;
          font-family: ${({ theme }) => theme.fontText} !important;
        }
      }
    }

    .ant-select-selector {
      background-color: ${({ theme }) => theme.softShadowGray};
      color: ${({ theme }) => theme.colorText} !important;
      border: 1px solid ${({ theme }) => theme.softSlateBlue};
    }

    .ant-select-selection-placeholder {
      color: ${({ theme }) => theme.colorText} !important;
      font-size: 16px;
      line-height: 28px;
    }

    .form-container {
      margin-top: 40px;
    }
  }

  .banners {
    padding-bottom: 39px;
    background-color: ${({ theme }) => theme.white};

    .slick-slider {
      margin-bottom: 0;

      .banner-image-wrapper {
        padding: 0;
      }

      .slick-dots-bottom {
        bottom: -32px;
      }
    }

    .banner_3 {
      padding: 40px 0;

      .slick-dots-bottom {
        bottom: -20px;
      }
    }

    .banner-wrapper {
      padding: 21px 0;
    }
  }

  @media only screen and (max-width: ${breakpoints.lg}px) {
    .category_name {
      font-size: 1.125rem !important;
    }
    .products-filters-container {
      .products-wrapper {
        padding-right: 0 !important;
      }
    }

    .form-container {
      display: none !important;
    }

    .category_name {
      display: block !important;
      font-size: 18px;
      font-weight: 600;
    }

    .products {
      justify-content: center !important;
    }
  }

  @media only screen and (max-width: ${breakpoints.xs}px) {
    .products {
      padding-top: 0 !important;
      gap: 15px !important;
      grid-template-columns: 1fr !important;
    }

    .discount-items {
      display: block;
      margin-top: 25px;

      .slick-dots-bottom {
        bottom: 0;
      }
    }

    .pagination {
      padding: 15px 0 33px 0 !important;
    }

    .banners {
      padding-bottom: 0;
      background-color: ${({ theme }) => theme.brightGrey};

      .desktop-banner {
        display: block;
      }

      .slick-dots {
        display: none !important;
      }

      .banner-wrapper {
        padding-top: 0;
      }
      .desktop-banner:first-child {
        padding-bottom: 0;
      }
    }

    .mobile-product-category {
      padding: 20px 0 44px 0;

      .title {
        padding: 0 20px;

        h1 {
          margin-top: 0;
        }
      }
    }
  }
`;
